import React from 'react';
import { CalendarIcon, ClockIcon } from 'lucide-react';
import { NetworkOrb } from './NetworkOrb';
import { author, site } from '../data/site';
export function ArticleHero() {
  return <header id="top" className="relative overflow-hidden border-b border-line" data-id="element-153" data-mp="3biebeofwuv77">
      <div className="mx-auto grid max-w-7xl items-center gap-10 px-5 pb-14 pt-12 md:px-8 md:pb-20 md:pt-16 lg:grid-cols-[minmax(0,1.3fr)_minmax(0,1fr)]" data-id="element-154" data-mp="36jkzh0g9vc95">
        <div data-id="element-155" data-mp="3ki1dzdkdm71u">
          <nav aria-label="Breadcrumb" className="text-sm text-faint" data-id="element-156" data-mp="3khjdg4qol6o4">
            <ol className="flex flex-wrap items-center gap-2" data-id="element-157" data-mp="3ggpqpeoz5xwt">
              <li data-id="element-158" data-mp="3u8w4wv8khutm"><a href="#top" className="hover:text-ink" data-id="element-159" data-mp="3u8w3cqsx5mri">Guides</a></li>
              <li aria-hidden="true" data-id="element-160" data-mp="3uba0d575t91p">/</li>
              <li aria-current="page" className="text-muted" data-id="element-161" data-mp="3p9swr1xaj8hf">AI workflow automation</li>
            </ol>
          </nav>

          <h1 className="mt-5 font-display text-4xl font-semibold leading-[1.08] tracking-tight text-ink sm:text-5xl lg:text-[3.6rem]" data-id="element-162" data-mp="82qt68mcu4h7">
            {site.title}
          </h1>

          <p className="mt-6 max-w-2xl text-lg leading-8 text-[#c3cae6]" data-id="element-163" data-mp="xp3hnyl88bbs">
            Choosing between{' '}
            <a href={site.tkxelServiceUrl} target="_blank" rel="noopener" className="inline-link" data-id="element-164" data-mp="12og3cg0d3ccs">
              ai workflow automation services
            </a>{' '}
            is less about who has the flashiest demo and more about who can connect AI to the systems
            your people already use, keep a human in charge of sensitive decisions and prove value in
            weeks rather than quarters. This guide profiles five providers doing that work for
            organisations in England, compares how they operate, and walks through the questions,
            metrics and steps that separate a successful rollout from an expensive pilot.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-muted" data-id="element-165" data-mp="1zdp1zjpwknb7">
            <a href="#author" className="flex items-center gap-3 hover:text-ink" data-id="element-166" data-mp="24cs0smfahxaq">
              <span className="grid h-9 w-9 place-items-center rounded-full bg-aurora-violet/25 text-xs font-semibold text-ink ring-1 ring-aurora-violet/40" data-id="element-167" data-mp="24afk0cl9psz9">
                {author.initials}
              </span>
              <span data-id="element-168" data-mp="e0c0fu8xrzte">By <span className="font-medium text-ink" data-id="element-169" data-mp="e029a3c5nmm4">{author.name}</span></span>
            </a>
            <span className="flex items-center gap-2" data-id="element-170" data-mp="99vm87xaka5z">
              <CalendarIcon className="h-4 w-4 text-faint" aria-hidden="true" data-id="element-171" data-mp="9812gwxrao3h" />
              <time dateTime={site.published} data-id="element-172" data-mp="mzyz48aa6rir">{site.publishedLabel}</time>
            </span>
            <span className="flex items-center gap-2" data-id="element-173" data-mp="iydhyaqprr2r">
              <ClockIcon className="h-4 w-4 text-faint" aria-hidden="true" data-id="element-174" data-mp="j1ro7u2i0kfh" />
              {site.readingTime}
            </span>
          </div>
        </div>

        <div className="relative mx-auto aspect-square w-full max-w-[280px] sm:max-w-[360px] lg:max-w-[440px]" data-id="element-175" data-mp="s1ena97r9e5d">
          <NetworkOrb data-id="element-176" data-mp="2yqt9peri3das" />
        </div>
      </div>
    </header>;
}